import React, {useState} from 'react';
import {circuit} from "../../../models/circuit";
import {scrollTo} from "../../../service/ToolsService";
import {NavLink} from "react-router-dom";
import {TableLineLoader} from "../../front/loader/TableLineLoader";
import DateService from "../../../service/DateService";
import {DeleteConfirme} from "../DeleteConfirme";
import {ApiService, filter, sort} from "../../../service/ApiService";
import {useForm} from "react-hook-form";

type FormDataType = {
  label?: string;
  distance?: number;
}

type CircuitListProps = {
  circuits: circuit[],
  loading?: boolean,
  sort: sort,
  refresh: () => void,
  filter: (f: filter[]) => void,
  order: (s: string) => void,
}

export const CircuitList = ({circuits, loading, sort, refresh, filter, order}: CircuitListProps) => {
  const [del, setDel] = useState(undefined as undefined | circuit);

  const deleteCircuit = async (circuit: circuit) => {
    await ApiService.delete(`/circuit/${circuit.circuitId}`);
    refresh();
  };

  const {
    register,
    handleSubmit,
  } = useForm<FormDataType>({
    defaultValues: {
      label: undefined,
      distance: undefined,
    }
  });

  const onSubmit = async (data: FormDataType) => {
    const filters: filter[] = []

    if ((data.label || undefined) !== undefined) {
      filters.push({
        op: 'like',
        field: 'label',
        value: `*${data.label}*`
      })
    }

    if ((data.distance || undefined) !== undefined) {
      filters.push({
        op: 'eq',
        field: 'distance',
        value: `${data.distance}`
      })
    }

    filter(filters);
  }

  return (
    <>
      <form method="post" onSubmit={handleSubmit(onSubmit)}>
        <table className="table table-responsive table-hover border">
          <thead>
          <tr className="table-primary">
            <th onClick={() => order('label')} className="cursor-pointer">
              <span className={sort.by === 'label' ? 'd-flex justify-content-between' : ''}>
                Nom
                {sort.by === 'label' && (<>
                  <i className={`me-2 fa-solid ${sort.direction === 'DESC' ? 'fa-sort-up' : 'fa-sort-down'}`} />
                </>)}
              </span>
            </th>
            <th onClick={() => order('distance')} className="cursor-pointer">
              <span className={sort.by === 'distance' ? 'd-flex justify-content-between' : ''}>
                Distance
                {sort.by === 'distance' && (<>
                  <i className={`me-2 fa-solid ${sort.direction === 'DESC' ? 'fa-sort-up' : 'fa-sort-down'}`} />
                </>)}
              </span>
            </th>
            <th className="text-center w150px">Modification</th>
            <th className="w200px"></th>
          </tr>
          </thead>
          <tbody>
          {loading && (
            <tr>
              <td colSpan={4} className="pt-4 pb-4 ps-5 pe-5">
                <TableLineLoader/>
              </td>
            </tr>
          )}
          <tr>
            <td>
              <input id="form-label" type="text" className="form-control" placeholder="~" {...register('label')} />
            </td>
            <td>
              <input id="form-label" type="text" className="form-control" placeholder="~" {...register('distance')} />
            </td>
            <td></td>
            <td className="text-center align-middle">
              <button type="submit" className="btn btn-sm btn-success me-1">ok</button>
            </td>
          </tr>
          {!loading && circuits.map((circuit: circuit, i: number) => (
            <tr key={i}>
              <td className="max-w400px">
                {circuit.label}
              </td>
              <td>
                {circuit.distance && (<>
                  {circuit.distance} km
                </>)}
              </td>
              <td className="text-center">
                {DateService
                  .toLocaleString(circuit.updatedAt ?? circuit.createdAt, {day: '2-digit', month: '2-digit', year: '2-digit', hour: '2-digit', minute: '2-digit', hour12: false})
                }
              </td>
              <td className="text-end">
                <NavLink to={`/admin/route/circuit/edit/${circuit.circuitId}`} onClick={scrollTo} className="btn btn-xs btn-primary me-1">
                  <i className="fa-solid fa-pencil me-1"/> modifier
                </NavLink>
                <button className="btn btn-xs btn-danger" onClick={() => setDel(circuit)}><i className="fa-solid fa-xmark me-1"/>supprimer</button>
              </td>
            </tr>
          ))}
          </tbody>
        </table>
      </form>

      {del && (
        <DeleteConfirme confirme={(c: boolean) => {
          if (c) {
            deleteCircuit(del);
          }

          setDel(undefined);
        }}/>
      )}
    </>
  )
}
